import translate from '../../../i18n'
import {
  IPlanFilterParams,
  PlanStatusEnums,
  PlanTypeEnums,
} from '../../../pages/plans-container/share-type'
import FormattedMessage from '../../intl/format-message'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Form, Input, Select } from 'antd'
import { useEffect } from 'react'

interface IPlanFilter {
  onSearch: (value: IPlanFilterParams) => void
  formData: IPlanFilterParams | undefined
}

const PlanFilter = (props: IPlanFilter) => {
  const { onSearch, formData } = props
  const [form] = Form.useForm()

  useEffect(() => {
    if (formData) {
      form.setFieldsValue(formData)
    }
  }, [form, formData])

  return (
    <Form
      form={form}
      layout="inline"
      className="filter-inline-form"
      onFinish={(values: IPlanFilterParams) => onSearch(values)}
    >
      <Form.Item name="name" label={translate('name')}>
        <Input allowClear />
      </Form.Item>
      <Form.Item name="planType" label={translate('plan.type')}>
        <Select
          style={{ minWidth: 160 }}
          allowClear
          options={Object.values(PlanTypeEnums).map(value => ({
            label: translate(`plan.type.${value}`),
            value,
          }))}
        />
      </Form.Item>
      <Form.Item name="status" label={translate('plan.status')}>
        <Select
          style={{ minWidth: 130 }}
          allowClear
          options={[
            { label: translate('plan.status.active'), value: PlanStatusEnums.ACTIVE },
            { label: translate('plan.status.archived'), value: PlanStatusEnums.ARCHIVED },
            { label: translate('plan.status.deleted'), value: PlanStatusEnums.DELETED },
          ]}
        />
      </Form.Item>
      <Form.Item name="isTopUp" label={translate('plan.isTopUp')}>
        <Select
          style={{ minWidth: 130 }}
          allowClear
          options={[
            { label: translate('yes'), value: true },
            { label: translate('no'), value: false },
          ]}
        />
      </Form.Item>
      <Form.Item name="isNewUserOnly" label={translate('plan.isNewUserOnly')}>
        <Select
          style={{ minWidth: 130 }}
          allowClear
          options={[
            { label: translate('yes'), value: true },
            { label: translate('no'), value: false },
          ]}
        />
      </Form.Item>
      <Form.Item>
        <Button htmlType="submit" type="primary" icon={<SearchOutlined />}>
          <FormattedMessage id="search" />
        </Button>
      </Form.Item>
    </Form>
  )
}

export default PlanFilter
